import { render, staticRenderFns } from "./ProviderItems.vue?vue&type=template&id=0f27616f"
import script from "./ProviderItems.vue?vue&type=script&lang=js"
export * from "./ProviderItems.vue?vue&type=script&lang=js"
import style0 from "./ProviderItems.vue?vue&type=style&index=0&id=0f27616f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports